import ga4 from "@/lib/tracking/ga4Core";

const ESTABLISHMENT_PHOTO_UPLOAD_JOURNEY_DETAILS = "establishment_photo_upload";

export const trackEstablishmentPhotoClickEvent = ({ target }) => {
  const eventName = "click_interaction";
  const eventParams = {
    target,
    journey_details: ESTABLISHMENT_PHOTO_UPLOAD_JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackAddEstablishmentPhotoFromSettings = () => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "add_establishment_logo",
    source: "update_profile_picture",
    journey_details: ESTABLISHMENT_PHOTO_UPLOAD_JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
